import { render, staticRenderFns } from "./lp-ticket-card.vue?vue&type=template&id=2a6e0d2b&"
import script from "./lp-ticket-card.vue?vue&type=script&lang=js&"
export * from "./lp-ticket-card.vue?vue&type=script&lang=js&"
import style0 from "./lp-ticket-card.vue?vue&type=style&index=0&id=2a6e0d2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports